import { render, staticRenderFns } from "./OurCommunityTab.vue?vue&type=template&id=150fe106&scoped=true&"
import script from "./OurCommunityTab.vue?vue&type=script&lang=js&"
export * from "./OurCommunityTab.vue?vue&type=script&lang=js&"
import style0 from "./OurCommunityTab.vue?vue&type=style&index=0&id=150fe106&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150fe106",
  null
  
)

export default component.exports